<template>
  <component
    :is="tag"
    :class="$b({ 'subtitle-over-title': subtitleAboveTitle, size})"
  >
    <!-- eslint-disable vue/no-v-html -->
    <span
      :class="$b('title')"
      v-html="productName"
    />

    <span
      v-if="subtitle"
      :class="$b('subtitle')"
      v-html="subtitle || '&nbsp;'"
    />
  </component>
</template>

<script>

export default {
  name: 'ProductTitle',

  props: {
    tag: { type: String, default: 'h1' },
    conversionKit: { type: Boolean, default: false },
    productName: { type: String, required: true },
    frameType: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    subtitleAboveTitle: { type: Boolean, default: true },
    size: {
      type: String,
      default: 'medium',
      validator(value) {
        return ['small', 'medium'].includes(value)
      }
    }
  },

  computed: {

  },
}
</script>

<style lang="postcss">
.ProductTitle {
  @apply flex gap-2 items-baseline flex-wrap;

  &--subtitle-over-title {
    @apply flex-col-reverse;
  }
}

.ProductTitle__title {
  @apply text-xl lg:text-2xl font-bold;
}

.ProductTitle__subtitle {
  .is-dark-chrome-theme & {
    @apply text-white;
  }
}

.ProductTitle__frame-type {
  @apply font-normal text-base;
}

/**
  Modifiers
*/
.ProductTitle--size-small {
  .ProductTitle__title {
    @apply text-sm;
  }
}
</style>
